import { render, staticRenderFns } from "./subMenuOverview.vue?vue&type=template&id=846a9ed6&"
import script from "./subMenuOverview.vue?vue&type=script&lang=js&"
export * from "./subMenuOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports